// extracted by mini-css-extract-plugin
export default {"container":"sidebar_mobile_container__c1M5+","image":"sidebar_mobile_image__LssSi"};